module.exports = __webpack_public_path__ + "assets-cabinet/img/on-cloud.dad8fbad.svg";